import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvFeedback, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';
import moment from 'moment';

import { createPushNotification, updatePushNotification, uploadNotificationImage } from '../../../actions';
import { FRONT_END_URL } from '../../../utils/Constants';

class CreateNotificationModal extends Component {
    constructor(props) {
        super(props);

        const { isEdit, currentNotificationData } = this.props.modalData;
        let dateTimeInputFriendly = isEdit && currentNotificationData.scheduled ?
            moment(currentNotificationData.dateTimeToPush, "DD-MM-YYYY HH:mm").format("YYYY-MM-DDTHH:mm")
            : null;
        let minDateTime = this.roundToNext15Min(moment().add(1, 'hour')).format('YYYY-MM-DDTHH:mm');

        this.state = {
            show: this.props.modalData.show,
            disableSubmit: false,
            invalidSchedule: false,
            unparsedDateTime: dateTimeInputFriendly,
            minDateTime: minDateTime,
            dateTimeWasFocused: false,
            notificationForm: {
                title: isEdit ? currentNotificationData.title : '',
                body: isEdit ? currentNotificationData.body : '',
                scheduled: isEdit ? currentNotificationData.scheduled : false,
                dateTimeToPush: isEdit ? currentNotificationData.dateTimeToPush : null,
                pictureUrl: isEdit ? currentNotificationData.pictureUrl : null
            },
            imagePreview: null
        };
    }

    roundToNext15Min = (momentElement) => {
        let intervals = Math.floor(momentElement.minutes() / 15);

        if (momentElement.minutes() % 15 !== 0)
            intervals++;
        if (intervals === 4) {
            momentElement.add('hours', 1);
            intervals = 0;
        }

        momentElement.minutes(intervals * 15);
        momentElement.seconds(0);

        return momentElement;
    };

    toggle = (refresh) => {
        this.setState({
            ...this.state,
            show: !this.state.show
        }, () => {
            setTimeout(() => {
                this.props.toggleModal(refresh);
            }, 500);
        });
    };

    setScheduledDateTime = ({ target }) => {
        let scheduledFor = moment(target.value, 'YYYY-MM-DD HH:mm');
        let validSchedule = scheduledFor.isAfter(moment().add(1, 'hour'));

        this.setState({
            ...this.state,
            disableSubmit: !validSchedule,
            invalidSchedule: !validSchedule,
            unparsedDateTime: target.value,
            notificationForm: {
                ...this.state.notificationForm,
                dateTimeToPush: scheduledFor.format('DD-MM-YYYY HH:mm')
            }
        });
    };

    changeScheduled = ({ target }) => {
        if (target) {

            let notificationForm = { ...this.state.notificationForm };

            if (target.value === 'instant') {
                notificationForm = {
                    ...notificationForm,
                    scheduled: false,
                    dateTimeToPush: null
                }
            } else {
                notificationForm = {
                    ...notificationForm,
                    scheduled: target.value === 'scheduled'
                }
            }

            this.setState({
                ...this.state,
                disableSubmit: false,
                invalidSchedule: false,
                notificationForm
            });
        }
    };

    updateFormData = ({ target }) => {
        this.setState({
            ...this.state,
            notificationForm: {
                ...this.state.notificationForm,
                [target.name]: target.value
            }
        });
    };

    handleFormSubmit = (invalidDateTimeInput) => {
        let copyPicture = this.props.modalData.isEdit && this.state.notificationForm.pictureUrl ? true : false

        if (moment(this.state.unparsedDateTime).isBefore() && this.state.notificationForm.scheduled) {
            this.setState({
                ...this.state,
                invalidSchedule: true,
                disableSubmit: true
            });

            return;
        }

        if (this.state.notificationForm.scheduled && (invalidDateTimeInput || this.state.notificationForm.dateTimeToPush === null)) {
            this.setState({
                ...this.state,
                dateTimeWasFocused: true
            });

            return;
        }

        this.setState({
            ...this.state,
            disableSubmit: true
        }, () => {
            if (!this.props.modalData.isEdit || (this.props.modalData.isEdit && this.props.modalData.currentNotificationData.pushNotificationStatus === 'SUCCESS')) {
                if (typeof (this.state.notificationForm.pictureUrl) === 'string' || !this.state.notificationForm.pictureUrl) {
                    this.props.createPushNotification(this.props.brandId, this.state.notificationForm, () => {
                        this.toggle(true);
                    }, copyPicture)
                } else {
                    this.props.uploadNotificationImage(this.props.brandId, this.state.notificationForm, () => {
                        this.toggle(true);
                    }, undefined, () => this.enableSubmitBtn());
                }
            } else {
                if (typeof (this.state.notificationForm.pictureUrl) === 'string' || !this.state.notificationForm.pictureUrl) {
                    this.props.updatePushNotification(this.props.modalData.currentNotificationData.id, this.state.notificationForm, () => {
                        this.toggle(true);
                    }, copyPicture);
                } else {
                    this.props.uploadNotificationImage(this.props.brandId, this.state.notificationForm, () => {
                        this.toggle(true);
                    }, this.props.modalData.currentNotificationData.id, () => this.enableSubmitBtn());
                }
            }
        });
    };

    uploadNotificationImage(event) {
        event.preventDefault();
        const file = event.target.files[0];

        if (file !== undefined) {                          // file === undefined when you click cancel
            this.setState({
                ...this.state,
                notificationForm: { ...this.state.notificationForm, pictureUrl: file },
                imagePreview: URL.createObjectURL(file)
            });
        }
    }

    deleteNotificationImage() {
        this.setState({
            ...this.state,
            notificationForm: { ...this.state.notificationForm, pictureUrl: null },
            imagePreview: null
        });
    }

    enableSubmitBtn = () => {
        this.setState({
            ...this.state,
            disableSubmit: false
        })
    }

    renderNotificationImage() {
        const { imagePreview } = this.state;
        const { pictureUrl } = this.state.notificationForm;

        const { figure, deleteButton } = styles;
        let imageSrc;
        let labelStyle;
        let imgStyle;

        if (imagePreview !== null && imagePreview !== undefined) {
            imageSrc = imagePreview;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 };
        } else if (pictureUrl === null) {
            imageSrc = imagePreview;
            labelStyle = 'coloured-label';
            imgStyle = { height: '100%', objectFit: 'cover', zIndex: 1 };
        } else {
            imageSrc = `${FRONT_END_URL}/${pictureUrl}`;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }
        }

        return (
            <div>
                <figure style={figure}>
                    {
                        this.state.notificationForm.pictureUrl || this.state.imagePreview ?
                            <div style={deleteButton} onClick={() => this.deleteNotificationImage()}><MaterialIcon
                                icon="delete_outline" color="#cdcdcd" size={26} /></div> :
                            null
                    }
                    <input id="notificationsImagePreview" className="custom-file-input" type="file" name="notificationsImagePreview" value={''}
                        onChange={(event) => this.uploadNotificationImage(event)} />
                    <label style={{ width: '150px', left: 'auto', transform: 'none' }} htmlFor="notificationsImagePreview">
                        <div style={{ display: 'flex', flexFlow: 'row wrap', justifyContent: 'center', textAlign: 'center' }}>
                            <span><MaterialIcon icon="local_see" size={30} /></span>
                            {i18n.t('common:buttons.fileUpload')}
                            <div style={{ fontSize: 12 }}>({i18n.t('screens:appNotificationScreen.specs')})</div>
                        </div>
                    </label>
                    <img style={imgStyle} src={imageSrc} />
                </figure>
            </div>
        );
    }

    render() {
        let invalidDateTimeInput = this.state.notificationForm.scheduled && this.state.dateTimeWasFocused && (this.state.notificationForm.dateTimeToPush === null || this.state.invalidSchedule);
        let isEditOfUnsend = !(!this.props.modalData.isEdit || (this.props.modalData.isEdit && this.props.modalData.currentNotificationData.pushNotificationStatus === 'SUCCESS'));
        const { notificationForm, textArea, scheduledGroup, datetimeLabel, datetimeInput, inputCounter, relativeElement, scheduleValidation, invalidField } = styles;

        return (
            <Modal isOpen={this.state.show} toggle={() => this.toggle(false)}>
                <ModalHeader toggle={() => this.toggle(false)}
                    className="modalHeader">{isEditOfUnsend ? i18n.t('screens:appNotificationScreen.createModal.headerUpdate') : this.props.modalData.isEdit ? i18n.t('screens:appNotificationScreen.createModal.headerCopy') : i18n.t('screens:appNotificationScreen.createModal.headerCreate')}</ModalHeader>
                <ModalBody>
                    <AvForm id="createNotificationForm" style={notificationForm} onValidSubmit={() => this.handleFormSubmit(invalidDateTimeInput)}>
                        <AvGroup style={relativeElement}>
                            <Label>{i18n.t('screens:appNotificationScreen.title')}</Label>
                            <AvInput
                                type="text"
                                name="title"
                                onChange={this.updateFormData}
                                value={this.state.notificationForm.title}
                                maxlength="40"
                                required />
                            <div style={inputCounter}>{40 - this.state.notificationForm.title.length} {i18n.t('screens:restaurantsMainContainer.of')} 40</div>
                            <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                        </AvGroup>
                        <AvGroup style={relativeElement}>
                            <Label>{i18n.t('screens:appNotificationScreen.body')}</Label>
                            <AvInput
                                style={textArea}
                                type="textarea"
                                name="body"
                                onChange={this.updateFormData}
                                value={this.state.notificationForm.body}
                                maxlength="500"
                                required />
                            <div style={inputCounter}>{500 - this.state.notificationForm.body.length} {i18n.t('screens:restaurantsMainContainer.of')} 500</div>
                            <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                        </AvGroup>
                        <br />
                        <div style={scheduledGroup}>
                            <AvRadioGroup value={this.state.notificationForm.scheduled ? 'scheduled' : 'instant'}
                                style={{ margin: 0 }} name="scheduled" onChange={this.changeScheduled}
                                required>
                                <AvRadio label={i18n.t('screens:appNotificationScreen.instant')} value="instant" />
                                <AvRadio label={i18n.t('screens:appNotificationScreen.scheduled')} value="scheduled" />
                            </AvRadioGroup>
                            {
                                this.state.notificationForm.scheduled ?
                                    <Fragment>
                                        <Label style={datetimeLabel}>{i18n.t('screens:appNotificationScreen.for')}</Label>
                                        <AvGroup for="timeToPush" style={datetimeLabel}>
                                            <Input
                                                style={invalidDateTimeInput ? { ...datetimeInput, ...invalidField } : datetimeInput}
                                                type="datetime-local"
                                                name="timeToPush"
                                                step="900"
                                                min={this.state.minDateTime}
                                                value={this.state.unparsedDateTime}
                                                onChange={this.setScheduledDateTime}
                                                required
                                                onBlur={() => {
                                                    this.setState({ ...this.state, dateTimeWasFocused: true })
                                                }}
                                            />
                                        </AvGroup>
                                    </Fragment> : null
                            }
                        </div>
                        {this.renderNotificationImage()}
                        {this.state.invalidSchedule && this.state.disableSubmit ?
                            <div style={scheduleValidation}>{i18n.t('screens:appNotificationScreen.createModal.scheduleHint')}</div>
                            : null}
                    </AvForm>
                </ModalBody>
                <ModalFooter>
                    <Button
                        type="submit"
                        form="createNotificationForm"
                        color="primary"
                        disabled={this.state.disableSubmit}
                    >
                        <MaterialIcon icon="check" color="#fff"
                            size={20} />&nbsp;{i18n.t('common:buttons.confirm')}</Button>{' '}
                    <Button color="outline-primary"
                        onClick={() => this.toggle(false)}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default connect(null, { createPushNotification, updatePushNotification, uploadNotificationImage })(CreateNotificationModal);

const styles = {
    notificationForm: {},
    textArea: {
        height: 100,
        resize: 'none'
    },
    scheduledGroup: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '1rem'
    },
    scheduledLabel: {
        margin: 0
    },
    scheduledCheckbox: {
        position: 'static'
    },
    datetimeLabel: {

        margin: 0
    },
    datetimeInput: {
        width: '270px',
    },
    invalidField: {
        color: '#DC3545',
        borderColor: '#DC3545'
    },
    relativeElement: {
        position: 'relative'
    },
    inputCounter: {
        position: 'absolute',
        right: 0,
        fontSize: 12,
        paddingTop: 5
    },
    scheduleValidation: {
        color: '#dc3545',
        fontSize: 12,
        paddingTop: 5
    },
    figure: {
        position: 'relative',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 225,
        width: 300,
        overflow: 'hidden',
        background: '#F0F0F0'
    },
    deleteButton: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        cursor: 'pointer',
        zIndex: 2
    }
};


// WEBPACK FOOTER //
// ./src/components/brands/AppNotificationScreen/CreateNotificationModal.js